import { parseWebVtt } from './parseWebVtt';
import { getSubtitleTextTracks, replaceTextTrackCues } from './replaceTextTrackCues';

export type FetchAndInjectVttCuesParams = {
  videoElement: Pick<HTMLMediaElement, 'textTracks'>;
  /** VTT URL from clip assets (e.g. centralized clip). Use `appendVttReloadCacheBust` when the path is unchanged. */
  vttUrl: string;
};

export type FetchAndInjectVttCuesResult = {
  cueCount: number;
  injectedTrackCount: number;
};

export const fetchAndInjectVttCues = async ({
  videoElement,
  vttUrl,
}: FetchAndInjectVttCuesParams): Promise<FetchAndInjectVttCuesResult> => {
  const response = await fetch(vttUrl);

  if (!response.ok) {
    throw new Error(`Failed to fetch VTT: ${response.status}`);
  }

  const cues = parseWebVtt(await response.text());
  const subtitleTracks = getSubtitleTextTracks(videoElement);

  if (subtitleTracks.length !== 1) {
    return {
      cueCount: cues.length,
      injectedTrackCount: 0,
    };
  }

  replaceTextTrackCues(subtitleTracks[0], cues);

  return {
    cueCount: cues.length,
    injectedTrackCount: 1,
  };
};
